import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UrlConstants } from "../../utils/ApiConstants";
import {
    useNavigate,
} from "react-router-dom";
import { Notification } from "../../components/notification/notification";
import CustomLoader from "../../components/loader";
import { Button, Card, Empty } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
interface Props {
    isLogin?: (val: any) => void;
}

const Redirect: React.FC<Props> = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const callback = queryParams.get('callback');
    const captureLocation = queryParams.get('capture-location');
    const navigate = useNavigate();
    const [loading, setLoading] = useState<Boolean>(true);
    const [message, setMessage] = useState<string>("Loading...");


    const downloadFile = async (url: string) => {
        setLoading(true);


        try {
            window.open(url, '_blank');

            setLoading(false);
            setMessage("Download Completed Successfully");
        } catch (error) {
            // window.open(url, '_blank');

            setLoading(false);
            setMessage("Download failed, Please try again ");
        }


    };

    const signInWithToken = async (token: string) => {
        try {
            const encodedToken = encodeURIComponent(token); // Ensure special characters are properly encoded
            const response = await axios.post(
                `${UrlConstants.BASE_URL}auth/api/proxy/token/signin?token=${encodedToken}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                localStorage.setItem("user", JSON.stringify(response.data)); // Use response.data instead of result
                navigate("/login");
                Notification("success",
                    "Logged In Successfully");
                // window.location.reload();
            } else {
                Notification("error",
                    "Error Logging In, PLease try again");
                throw new Error("Sign-in failed");

            }
        } catch (error) {
            Notification("error",
                "Error Logging In, PLease try again");
            // console.error("Error signing in:", error);
            navigate("/login");
        }
    };

    useEffect(() => {
        if (token) {
            signInWithToken(token);
        }
    }, [token]);


    useEffect(() => {
        if (callback) {
            if (captureLocation) {
                registerLocation();
            } else {
                const url = `${callback}`;
                downloadFile(url);
                setLoading(false);
                setMessage("Download started, you can close this window.");

            }
        }
    }, [callback, captureLocation]);

    const registerLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const url = `${callback}&latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`;
                    downloadFile(url);
                    setLoading(false);
                    setMessage("Download started, you can close this window.");

                },
                (error) => {
                    console.error("Error getting geolocation: ", error);
                }
            );
        } else {
            setMessage("Please enable location in your browser, and try again!");
        }
    };

    return (
        loading ? <><div className="text-center py-5">
            <CustomLoader size="lg"></CustomLoader>
        </div></> : (
            <div className="my-4 text-center font-semibold text-lg text-primary">
                <Card style={{ width: '40%', margin: 'auto' }}>
                    <Empty
                        image={<DownloadOutlined style={{ fontSize: 64, opacity: 0.6 }} className="text-primary" />}
                        description={<p className="my-2 text-lg"> {message} </p>}
                    />
                    <Button className="mx-3 mt-3" type="primary" onClick={registerLocation}>Download Again</Button>
                </Card>
            </div>
        )
    );
}

export default Redirect;